export default __webpack_public_path__ + "static/media/shopperr_logo.b4267979.png";